import React from 'react'
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// Component to push user identification to GTM dataLayer
const GTMUserIdentifier = ({ children }) => {
  const { isAuthenticated, user } = useAuth0()

  React.useEffect(() => {
    if (isAuthenticated && user && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'user_identified',
        user_id: user.sub,
        user_email: user.email,
        user_name: user.name,
        user_given_name: user.given_name,
        user_family_name: user.family_name,
        is_authenticated: true
      })
    }
  }, [isAuthenticated, user])

  return children
}

export const wrapRootElement = ({ element }) => (
  <Auth0Provider
    domain={process.env.GATSBY_AUTH0_DOMAIN}
    clientId={process.env.GATSBY_AUTH0_CLIENT_ID}
    redirectUri={window.location.origin}
    audience={`https://${ process.env.GATSBY_AUTH0_DOMAIN }/api/v2/`}
    scope="profile email users read:current_user"
    connection={process.env.GATSBY_AUTH0_CONNECTION}
  >
    <GoogleReCaptchaProvider reCaptchaKey={process.env.GATSBY_RECAPTCHA_V3_SITE_KEY}>
      <GTMUserIdentifier>
        {element}
      </GTMUserIdentifier>
    </GoogleReCaptchaProvider>
  </Auth0Provider>
)
